import { render, staticRenderFns } from "./ListTuTestimonials.vue?vue&type=template&id=e3f570f6&scoped=true&"
import script from "./ListTuTestimonials.vue?vue&type=script&lang=js&"
export * from "./ListTuTestimonials.vue?vue&type=script&lang=js&"
import style0 from "./ListTuTestimonials.vue?vue&type=style&index=0&id=e3f570f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3f570f6",
  null
  
)

export default component.exports